import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, ShieldQuestion } from "lucide-react";
import { severityColor } from "@/components/common/ui";

export default function InsightCard({ insight, index = 0 }) {
  const navigate = useNavigate();
  const col = severityColor(insight.severity);
  const conf = Math.round((insight.confidence || 0) * 100);
  return (
    <div data-testid={`insight-${insight.id}`}
      className="careiq-rise overflow-hidden rounded-xl border bg-card shadow-sm"
      style={{ animationDelay: `${index * 80}ms`, borderLeft: "3px solid #7C3AED" }}>
      <div className="flex items-center justify-between px-4 pt-3.5">
        <div className="flex items-center gap-2">
          <Sparkles size={15} className="text-[#7C3AED]" />
          <span className="text-[11px] font-semibold uppercase tracking-widest text-[#7C3AED]">AI Insight · {insight.module}</span>
        </div>
        <span className="rounded-full px-2 py-0.5 text-xs font-semibold" style={{ color: col, backgroundColor: `${col}1a` }}>
          {insight.severity}
        </span>
      </div>

      <div className="px-4 py-3">
        <p className="text-sm font-semibold leading-snug">{insight.what}</p>
        <div className="mt-3 space-y-2 text-[13px]">
          <Row label="Why it matters" value={insight.why} />
          <div>
            <div className="overline mb-1">Evidence</div>
            <ul className="space-y-1">
              {(insight.evidence || []).map((e, i) => (
                <li key={i} className="flex items-start gap-2 text-muted-foreground">
                  <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-[#7C3AED]" /> {e}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-3 flex items-center gap-3">
          <div className="flex-1">
            <div className="mb-1 flex items-center justify-between">
              <span className="overline">Confidence</span>
              <span className="text-xs font-bold">{conf}%</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
              <div className="h-full rounded-full bg-[#7C3AED]" style={{ width: `${conf}%`, transition: "width 0.8s ease" }} />
            </div>
          </div>
        </div>

        <div className="mt-3 rounded-lg border bg-background p-3">
          <div className="overline mb-1">Recommended action</div>
          <p className="text-[13px]">{insight.action}</p>
          <div className="mt-2 flex items-center gap-1.5 text-[11px] font-medium text-[#F79009]">
            <ShieldQuestion size={13} /> {insight.human_decision}
          </div>
        </div>

        <div className="mt-3 flex flex-wrap gap-2">
          {(insight.links || []).map((l, i) => (
            <button key={i} data-testid={`insight-link-${insight.id}-${i}`} onClick={() => navigate(l)}
              className="flex items-center gap-1 rounded-md border bg-background px-2.5 py-1 text-xs font-medium transition-colors hover:border-[#155EEF] hover:text-[#155EEF]">
              {l.replace("/", "").replace("-", " ") || "view"} <ArrowRight size={12} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div>
      <div className="overline mb-0.5">{label}</div>
      <p className="text-muted-foreground">{value}</p>
    </div>
  );
}
